import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BookingSuccess from './pages/BookingSuccess';
import BookingConfirmed from './pages/BookingConfirmed';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

const routerBasename =
  typeof window !== 'undefined' && window.location.pathname.startsWith('/neruda-tours')
    ? '/neruda-tours'
    : '';

export default function App() {
  return (
    <BrowserRouter basename={routerBasename}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/booking-success" element={<BookingSuccess />} />
        <Route path="/booking/:reference" element={<BookingConfirmed />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
